import {Root, Trigger} from '@radix-ui/react-dialog';

export const Dialog = Root;
export const DialogTrigger = Trigger;

export * from './DialogBody';
export * from './DialogContent';
export * from './DialogIcon';
export * from './DialogTitle';
export * from './DialogDescription';
export * from './DialogButtons';
